import React from 'react';
import { Helmet } from 'react-helmet';
import { Briefcase, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import PlatformBenefits from './components/PlatformBenefits';
import ApplicationForm from './components/ApplicationForm';

const PublicPartnerApplicationForm: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Partner Application - TravelHeroes Vienna</title>
        <meta
          name="description"
          content="Join TravelHeroes as a partner and connect with thousands of tourists exploring Vienna. Zero commission, increased visibility, and targeted marketing."
        />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center">
                  <Briefcase className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">TravelHeroes</h1>
                  <p className="text-sm text-gray-600">Partner Application Portal</p>
                </div>
              </div>
              <Link
                to="/"
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                <span>Back to Home</span>
              </Link>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          {/* Hero Section */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              Become a TravelHeroes Partner
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Connect your Vienna business with thousands of tourists and travelers. Create exclusive
              offers, increase visibility, and grow your customer base with zero commission fees.
            </p>
          </div>

          {/* Platform Benefits */}
          <PlatformBenefits />

          {/* Application Form */}
          <div className="mt-12">
            <ApplicationForm />
          </div>

          {/* Footer Info */}
          <div className="mt-12 text-center text-sm text-gray-600">
            <p className="mb-2">
              Questions about the partnership program?{' '}
              <a href="mailto:partners@travelheroes.com" className="text-indigo-600 hover:text-indigo-700">
                Contact our team
              </a>
            </p>
            <p>
              Applications are reviewed within 2-3 business days. You will receive an email notification
              regarding your application status.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PublicPartnerApplicationForm;